import client from "./client";

export const history = locale => client.post(`/api/${locale}/sbjUser/history`);
